import Navbar from "../../../components/Navbar";
import Player from "../../../components/Student/Player";

export default function PlayerPage() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="grid grid-cols-3 gap-2 lg:gap-8">
            <Player />
          </div>
        </div>
      </section>
    </>
  );
}
